import clsx from 'clsx'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {FORMAT_CHATBOT_DATE_TIME, MESSAGE_TYPE, SENDER_TYPE} from '../../definitions'
import {useChatbotContext} from '../../context'
import {v4 as uuid} from 'uuid'
import {TypingDots} from '../atoms/TypingAnimation'
import moment from 'moment'

export const ChatbotInput = () => {
  const intl = useIntl()
  const {addMessage, handleCreateMessage, disabledUserAction, isSendingMessage} =
    useChatbotContext()
  const [text, setText] = useState('')

  const onKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // NOTE: Allow shift + enter for new line
        return
      }

      // NOTE: Prevent default behavior of Enter key
      e.preventDefault()

      if (!text.trim().length) {
        setText('')
        return
      }
      if (disabledUserAction) return

      const inputMessageId = uuid()
      addMessage({
        id: inputMessageId,
        content: text,
        sender: SENDER_TYPE.USER,
        type: MESSAGE_TYPE.TEXT,
        created_at: moment.utc().format(FORMAT_CHATBOT_DATE_TIME),
      })

      handleCreateMessage({
        message: text,
        type: MESSAGE_TYPE.TEXT,
        newMessageId: inputMessageId,
      })
      setText('')
    }
  }

  return (
    <>
      {isSendingMessage && (
        <TypingDots className='h-50px d-flex align-items-center ps-6 bg-transparent' />
      )}
      <div className='border-top border-top-1 border-top-gray-100 p-2'>
        <div className='d-flex align-items-center justify-content-between w-100 gap-2'>
          <textarea
            autoComplete='off'
            placeholder={intl.formatMessage({id: 'CHATBOT_MESSAGE_PLACEHOLDER'})}
            className={clsx(`form-control fs-6 chatbot-input`)}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={onKeyDown}
          />
          {/* TODO: [N] Voice and File are in next phase */}
          {/* <div className={'d-flex align-items-center gap-2'}>
            <div className='btn-icon text-hover-primary cursor-pointer w-30px'>
              <KTSVG
                path='/media/gori/chatbot/record.svg'
                className={clsx('svg-icon svg-icon-1')}
              />
            </div>
            <div className='btn-icon text-hover-primary cursor-pointer w-30px'>
              <KTSVG
                path='/media/gori/chatbot/attachment.svg'
                className={clsx('svg-icon svg-icon-1')}
              />
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}
